export default "__VITE_ASSET__CsOmPcLI__"